import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import logo from '../../../assets/logo/smart-is-white-logo.svg';
import { ErrorFallback } from 'smart-react';
import Loader from '../../Core/Components/Loader/Loader';
import LoginForm from './LoginForm';
/**
 * Main Login Screen
 * @returns {React.Element} returns main login screen
 */
const Splash = () => {
  const [isLoader, setIsLoader] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="tw">
        {isLoader && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/20 backdrop-blur-[4px]">
            <Loader />
          </div>
        )}
        <div className="min-h-screen bg-white">
          <div className="grid min-h-screen grid-cols-1 md:grid-cols-2">
            <section
              className="flex h-[220px] items-center justify-center bg-black px-6 md:min-h-screen md:px-10"
              aria-label="SMART IS brand"
            >
              <img
                src={logo}
                className="w-[220px] max-w-full md:w-[320px] lg:w-[420px]"
                alt={`${process.env.APP_NAME} Logo`}
              />
            </section>

            <section
              className="flex items-center justify-center bg-white px-5 py-10 md:min-h-screen md:px-8 lg:px-12"
              aria-label="Sign in"
            >
              <div className="w-full max-w-[440px]">
                <div className="mx-auto mb-10 text-center md:mb-12">
                  <h1 className="text-[23px] font-bold leading-[1.25] text-[#374151]">
                    Let&apos;s Sign You In.
                  </h1>
                  <p className="mt-[14px] text-[15px] font-normal leading-[1.45] text-[#4b5563]">
                    To Continue, first Verify that it&apos;s You.
                  </p>
                </div>

                <LoginForm isLoader={isLoader} setIsLoader={setIsLoader} />
              </div>
            </section>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default Splash;
